/**
 * used to throttle expensive animation or scroll based event listeners
 * @param {Function} fn callback function to run on next animation
 */
export default
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function(fn) {
        setTimeout(fn, 1000 / 60);
    };
